$(function() {
	// Get the HTML DOM element that will contain your map
	// We are using a div with id="map" seen below in the <body>
	var mapElement = document.getElementById('map');

	if (mapElement !== null) {
		// When the window has finished loading create our google map below
		//google.maps.event.addDomListener(window, 'load', init);
		//function init() {
			// Basic options for a simple Google Map

			// For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
			var mapOptions = {
				// How zoomed in you want the map to start at (always required)
				zoom: 7,
				mapTypeControl: false,
				fullscreenControl: false,

				// The latitude and longitude to center the map (always required)
				center: new google.maps.LatLng(51.285436, -1.344206), // central point for all properties

				// How you would like to style the map.
				// This is where you would paste any style found on Snazzy Maps.
				styles: [
					{ featureType: 'all', elementType: 'geometry.fill', stylers: [{ weight: '2.00' }] },
					{ featureType: 'all', elementType: 'geometry.stroke', stylers: [{ color: '#9c9c9c' }] },
					{ featureType: 'all', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
					{ featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f2f2f2' }] },
					{ featureType: 'landscape', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
					{ featureType: 'landscape.man_made', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
					{ featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
					{ featureType: 'road', elementType: 'all', stylers: [{ saturation: -100 }, { lightness: 45 }] },
					{ featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#eeeeee' }] },
					{ featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#7b7b7b' }] },
					{ featureType: 'road', elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] },
					{ featureType: 'road.highway', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
					{ featureType: 'road.arterial', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
					{ featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
					{ featureType: 'water', elementType: 'all', stylers: [{ color: '#b0bdc8' }, { visibility: 'on' }] },
					{ featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#b0bdc8' }] },
					{ featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#070707' }] },
					{ featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] }
				]
			};

			// Create the Google Map using our element and options defined above
			var map = new google.maps.Map(mapElement, mapOptions);

			if ($(window).width() < 600) {
				map.setZoom(6);
			}

			// markers
			var markers = [];

			$('#properties div[data-marker]').each(function(i, el) {
				var $el = $(el);

				var marker = new google.maps.Marker({
					position: new google.maps.LatLng($el.data('lat'), $el.data('lng')),
					map: map,
					title: $el.data('name'),
					icon: {
						url: $el.data('marker')
					}
				});

				markers.push(marker);
			});

			// panels

			/*markers.forEach(function(marker) {
				if (marker.categories.contains('hide-pin')) {
					marker.setVisible(false);
				}

				marker.addListener('click', function() {
					if (marker.categories.contains('double-pin')) {
						map.panTo(marker.getPosition());
						map.setZoom(14);
						marker.setVisible(false);

						markers.forEach(function(marker) {
							if (marker.categories.contains('hide-pin')) {
								marker.setVisible(true);

								if ($(window).width() > 600) {
									$('#the-manor-house').show();
								}

								$('#map').css({ height: $(marker.panel).height() + 'px' });

								marker.addListener('click', function() {
									//alert ('hi');
									map.panTo(marker.getPosition());
									map.setZoom(20);
									$('.panel').hide();
									$(marker.panel).show();
									$('#map').css({ height: $(marker.panel).height() + 'px' });
								});
							}
						});
					} else if (marker.categories.contains('hide-pin')) {
						if ($(window).width() < 600) {
							$('html,body').animate(
								{
									scrollTop: $('#properties').offset().top - 67
								},
								'slow'
							);
						}
					} else {
						$('.panel').hide();
						$(marker.panel).show();
						$('#map').css({ height: $(marker.panel).height() + 'px' });
						map.panTo(marker.getPosition());
						map.setZoom(12);

						if ($(window).width() < 600) {
							$('html,body').animate(
								{
									scrollTop: $('#properties').offset().top - 67
								},
								'slow'
							);
						}
					}
				});
			});*/
		//}

		Array.prototype.contains = function(obj) {
			var i = this.length;
			while (i--) {
				if (this[i] === obj) {
					return true;
				}
			}
			return false;
		};
	}
});
